module.exports = __webpack_public_path__ + "img/logo.bc8b7379.png";